import React, { FC, useState } from "react"
import {
  Modal,
  TextField,
  Button,
  CircularProgress,
  InputAdornment,
  IconButton,
  OutlinedInput,
} from "@material-ui/core"
import { updateUserPassword } from "../../../../actions"
import { User } from "../../../../types"
import styles from "./styles.module.scss"
import { Visibility, VisibilityOff } from "@material-ui/icons"

interface UpdateUserPasswordModalProps {
  listItem: User | null
  fetchData: () => void
  hideModal: () => void
}

export const UpdateUserPasswordModal: FC<UpdateUserPasswordModalProps> = ({ listItem, hideModal, fetchData }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [password, setPassword] = useState<string>("")
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const handleClickShowPassword = () => setShowPassword(show => !show)
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const onPressSubmit = async () => {
    if (!listItem) return

    setIsLoading(true)

    const response = await updateUserPassword(listItem.id, password)
    setShowConfirm(false)
    setIsLoading(false)
    if (response?.error) {
      setErrorMessage(response?.message || response?.error || "Something went wrong")
    } else {
      hideModal()
    }
  }

  const passwordStep = (
    <>
      <h2>Change password for {listItem?.username}</h2>
      <OutlinedInput
        className={styles.modalInput}
        fullWidth
        required
        onChange={event => setPassword(event.target.value)}
        placeholder="*********"
        error={!!errorMessage}
        value={password}
        disabled={isLoading}
        type={showPassword ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
      <div className={styles.buttonContainer}>
        <Button variant="contained" size="small" onClick={() => setShowConfirm(true)} disabled={!password}>
          Submit
        </Button>
      </div>
    </>
  )

  const confirmStep = (
    <>
      <h2>Are you sure you'd like to change password for {listItem?.username}?</h2>
      {isLoading ? (
        <CircularProgress size={30} />
      ) : (
        <div className={styles.buttonContainer}>
          <div className={styles.button}>
            <Button variant="contained" size="small" onClick={() => setShowConfirm(false)}>
              NO
            </Button>
          </div>
          <div className={styles.button}>
            <Button variant="contained" size="small" onClick={onPressSubmit}>
              YES
            </Button>
          </div>
        </div>
      )}
    </>
  )

  return (
    <div className={styles.modalBody}>
      <Modal className={styles.modal} open={!!errorMessage} onClose={() => setErrorMessage(null)}>
        <div className={styles.errorModal}>
          <h3>{errorMessage}</h3>
          <div className={styles.button}>
            <Button variant="contained" size="small" onClick={() => setErrorMessage(null)}>
              Close
            </Button>
          </div>
        </div>
      </Modal>
      {showConfirm ? confirmStep : passwordStep}
    </div>
  )
}
